import {
	StyleSheet,
	View,
	Text,
	TouchableOpacity,
	SafeAreaView,
} from "react-native";
import React from "react";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { getPrimaryColor } from "../../../utils/ColorsFunctions";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { useTheme } from "react-native-paper";

const ServicesHubHeader = () => {
	const navigation = useNavigation();
	//const user = useAppSelector(s => s.auth.subUser!);
	const { colors } = useTheme();

	return (
		<SafeAreaView style={styles.root}>
			<TouchableOpacity
				style={[
					styles.pressable,
					{ backgroundColor: colors.figmaBackgroundColor },
				]}
				onPress={navigation.goBack}
			>
				<Ionicons name="chevron-back" size={24} color={colors.pureWhite} />
				<View style={styles.title}>
					<Text style={[styles.text, { color: colors.pureWhite }]}>
						Serviços
					</Text>
				</View>
			</TouchableOpacity>
		</SafeAreaView>
	);
};

export default ServicesHubHeader;

const styles = StyleSheet.create({
	root: { backgroundColor: "#0843F5" },
	pressable: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#fff",
		padding: 20,
	},
	title: {
		alignItems: "center",
		marginLeft: -28,
		flex: 1,
	},
	text: {
		fontWeight: "500",
		fontSize: 20,
		lineHeight: 26,
	},
});
